var Backbone, FAQArticleView, FaqDetailedarticleTemplate, FaqSummarizedarticleTemplate, Hogan, SharedUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedUtilsHelper = require('../../../shared/frontend/helpers/utils');

Hogan = require('../../../../node_modules/hogan.js/web/builds/2.0.0/hogan-2.0.0');

Backbone = require('backbone');

Backbone.$ = $;

FaqDetailedarticleTemplate = require('../../detailedarticle.html.mustache');

FaqSummarizedarticleTemplate = require('../../summarizedarticle.html.mustache');

FAQArticleView = (function(superClass) {
  extend(FAQArticleView, superClass);

  function FAQArticleView() {
    return FAQArticleView.__super__.constructor.apply(this, arguments);
  }

  FAQArticleView.VIEWID = 2;

  FAQArticleView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.deatiledArticleTemplate = FaqDetailedarticleTemplate;
    this.summarizedArticleTemplate = FaqSummarizedarticleTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.summarized = this.options.summarized ? true : false;
    this.container = this.options.container;
    this.contentModel = this.options.contentModel;
    this.truncationLimit = 200;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQArticleView.prototype.events = {
    "click .rating": "handleRatingClicked"
  };

  FAQArticleView.prototype.render = function(topicId, articleId) {
    var data, errorCb, successCallack;
    this.searchId = "" + topicId + articleId;
    data = this.getArticleHash();
    if (this.checkArticleId(articleId, data)) {
      return this.constructArticlePage(data);
    } else {
      successCallack = (function(_this) {
        return function(response) {
          return _this.constructArticlePage(response);
        };
      })(this);
      errorCb = (function(_this) {
        return function(data) {
          if (data == null) {
            data = {};
          }
          return _this.errorCallback(data);
        };
      })(this);
      return this.contentModel.fetchContent({
        topicId: topicId,
        articleId: articleId,
        searchId: this.searchId,
        category: "article"
      }, successCallack, errorCb);
    }
  };

  FAQArticleView.prototype.errorText = function() {
    if (Groupon.FAQ.ViewManager.isV2View()) {
      return I18n.t('js.modules.faq.refresh_browser');
    } else {
      return I18n.t('js.modules.faq.not_found');
    }
  };

  FAQArticleView.prototype.checkArticleId = function(articleId, data) {
    if ((data != null ? data.article : void 0) != null) {
      return data.article.id === articleId;
    } else {
      return false;
    }
  };

  FAQArticleView.prototype.getArticleHash = function() {
    var data;
    data = this.contentModel.attributes;
    if ((data != null ? data.article : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQArticleView.prototype.constructArticlePage = function(response) {
    var articleHash, ref, ref1, topicHash;
    if ((response != null) && (response.article != null) && (response.topic != null)) {
      topicHash = {
        searchId: response.topic.searchId,
        text: (ref = response.topic.text) != null ? ref.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(topicHash);
      articleHash = {
        searchId: response.article.searchId,
        text: (ref1 = response.article.heading) != null ? ref1.replace(/(<([^>]+)>)/ig, "") : void 0
      };
      this.breadCrumbView.addCrumbs(articleHash);
      return this.toHtml(response);
    } else {
      return this.invalidResponseCallback({
        searchId: this.searchId
      });
    }
  };

  FAQArticleView.prototype.toHtml = function(response) {
    var hash;
    if (response.article != null) {
      if (response.article.heading != null) {
        response.article.heading = response.article.heading.replace(/(<([^>]+)>)/ig, "");
      }
      this.temporaryArticleTemplate = Hogan.compile(response.article.text);
      response.article.text = toHtml(this.temporaryArticleTemplate, window.currentUser, this.I18nScope);
      if (this.summarized) {
        return this.constructSummarizedArticle(response);
      } else {
        hash = $.extend(true, {}, response.article, window.currentUser);
        this.$el.html(toHtml(this.deatiledArticleTemplate, hash, this.I18nScope));
        this.breadCrumbView.render();
        return this.container.html(this.el);
      }
    }
  };

  FAQArticleView.prototype.constructSummarizedArticle = function(response) {
    var hash, indexOfSpace, orgContent, ref, truncatedContent;
    hash = $.extend(true, {}, response.article, window.currentUser);
    this.$el.html(toHtml(this.summarizedArticleTemplate, hash, this.I18nScope));
    this.$('.article-text-container').dotdotdot({
      height: 60
    });
    orgContent = this.$('.article-text-container').triggerHandler("originalContent");
    orgContent = orgContent != null ? (ref = orgContent.text()) != null ? ref.trim() : void 0 : void 0;
    if ((orgContent != null ? orgContent.length : void 0) > this.truncationLimit) {
      indexOfSpace = orgContent.indexOf(' ', this.truncationLimit);
      if (indexOfSpace > -1) {
        truncatedContent = orgContent.substring(0, indexOfSpace);
      } else {
        truncatedContent = orgContent;
      }
      truncatedContent = truncatedContent + "...<a class='read-more' searchId='" + response.article.searchId + "' href='#" + response.article.searchId + "'>" + (I18n.t("js.modules.faq.readmore")) + "</a>";
      this.$('.truncated-article-container').html(truncatedContent);
    } else {
      this.$('.article-text-container').show();
    }
    return this.container.append(this.el);
  };

  FAQArticleView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target);
    if ($target.is("a")) {
      propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          $(".ratings", _this.$el).hide();
          return $(".thanks", _this.$el).show();
        };
      })(this));
    }
    return true;
  };

  FAQArticleView.prototype.errorCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-articles-api-failure' class='noResults'>" + (this.errorText()) + "</div>"
    });
  };

  FAQArticleView.prototype.invalidResponseCallback = function(data) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: data.searchId,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(data.searchId)) + "___no-results-displayed-for-articles-api-invalid' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  return FAQArticleView;

})(Backbone.View);

module.exports = FAQArticleView;

//# sourceMappingURL=data:application/json;base64,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
